export default __webpack_public_path__ + "static/media/E2BAuto-728x90-px.cfa4845f.jpg";